import {
  Box,
  BoxProps,
  Stack,
  Typography
} from "@mui/material";
import { common } from "@mui/material/colors";
import {
  alpha,
  styled
} from "@mui/material/styles";
import {
  ButtonBookmark,
  ButtonLink,
  ButtonProps,  Icon,
  StatusBox
} from "../../components";
import { CtaOverlayContainer } from "../CtaOverlay/CtaOverlay.styles";
import { PlayerLoader } from "../PlayerLoader";

export const StyledButtonBookmark = styled(ButtonBookmark)<
  ButtonProps & { $selected: boolean }
>(({ $selected, theme }) => ({
  alignItems: "center",
  border: "none",
  bottom: "45px",
  cursor: "pointer",
  display: "flex",
  height: "30px",
  minWidth:"30px",
  opacity: 0,
  padding: 0,
  position: "absolute",
  right: 0,
  transition: "all .1s ease 0s",
  zIndex: "1",

  "&:before": {
    /* eslint-disable max-len */
    backgroundImage: $selected
      ? `url("data:image/svg+xml,%3Csvg width='26' height='26' viewBox='0 0 26 26' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M3.60938 5.52266C3.60938 3.8425 3.60938 3.00242 3.93636 2.36068C4.22398 1.7962 4.68292 1.33726 5.2474 1.04964C5.88914 0.722656 6.72922 0.722656 8.40938 0.722656H20.4766C22.1567 0.722656 22.9968 0.722656 23.6385 1.04964C24.203 1.33726 24.662 1.7962 24.9496 2.36068C25.2766 3.00242 25.2766 3.8425 25.2766 5.52266V17.5898C25.2766 19.27 25.2766 20.1101 24.9496 20.7518C24.662 21.3163 24.203 21.7752 23.6385 22.0629C22.9968 22.3898 22.1567 22.3898 20.4766 22.3898H8.40938C6.72922 22.3898 5.88914 22.3898 5.2474 22.0629C4.68292 21.7752 4.22398 21.3163 3.93636 20.7518C3.60938 20.1101 3.60938 19.27 3.60938 17.5898V5.52266Z' fill='%23${theme.customColors.systemPrimary02.replace("#", "")}' opacity='0.7'/%3E%3Cpath d='M21.9618 23.0283H7.02211C4.78694 23.0283 2.98438 21.2102 2.98438 18.9882V4.05447C2.98438 2.79917 3.5612 1.63045 4.54179 0.865724C4.84462 0.620435 5.30608 0.67815 5.55122 0.995582C5.79637 1.31301 5.73869 1.7603 5.42144 2.00559C4.78694 2.49617 4.412 3.24646 4.412 4.0689V18.9882C4.412 20.4167 5.58007 21.5854 7.00769 21.5854H21.9473C23.375 21.5854 24.543 20.4167 24.543 18.9882V4.04004C24.543 3.34747 24.269 2.69817 23.7787 2.19317C23.2884 1.70259 22.6395 1.42844 21.9329 1.42844H9.25729C8.85352 1.44287 8.53627 1.12544 8.53627 0.721436C8.53627 0.317432 8.85352 0.0144287 9.25729 0.0144287H21.9618V0C23.0433 0 24.0527 0.418433 24.817 1.18316C25.5813 1.94788 25.9995 2.95789 25.9995 4.04004V18.9882C25.9995 21.2247 24.1825 23.0283 21.9618 23.0283Z' fill='%23${theme.customColors.systemPrimary02.replace("#", "")}'/%3E%3Cpath d='M22.6979 25.9995H5.77791C2.16672 25.9995 0 22.1868 0 20.0201V5.06341C0 4.58726 0.115364 4.13997 0.331672 3.72154C0.519138 3.36082 0.951753 3.23096 1.29785 3.4041C1.65836 3.59168 1.78814 4.02454 1.6151 4.37083C1.49973 4.58726 1.44205 4.81812 1.44205 5.06341L1.44448 19.4995C1.44448 20.944 2.88896 24.5552 6.50015 24.5552L22.6979 24.5278C23.1593 24.5278 23.6064 24.3402 23.938 23.9795C24.212 23.6909 24.6735 23.6765 24.9619 23.9506C25.2503 24.2248 25.2647 24.6865 24.9763 24.9751C24.3562 25.6243 23.5487 25.9706 22.6834 25.9706L22.6979 25.9995Z' fill='%23${theme.customColors.systemPrimary02.replace("#", "")}'/%3E%3C/svg%3E%0A");`
      : `url("data:image/svg+xml,%3Csvg width='26' height='26' viewBox='0 0 26 26' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M3.60938 5.52266C3.60938 3.8425 3.60938 3.00242 3.93636 2.36068C4.22398 1.7962 4.68292 1.33726 5.2474 1.04964C5.88914 0.722656 6.72922 0.722656 8.40938 0.722656H20.4766C22.1567 0.722656 22.9968 0.722656 23.6385 1.04964C24.203 1.33726 24.662 1.7962 24.9496 2.36068C25.2766 3.00242 25.2766 3.8425 25.2766 5.52266V17.5898C25.2766 19.27 25.2766 20.1101 24.9496 20.7518C24.662 21.3163 24.203 21.7752 23.6385 22.0629C22.9968 22.3898 22.1567 22.3898 20.4766 22.3898H8.40938C6.72922 22.3898 5.88914 22.3898 5.2474 22.0629C4.68292 21.7752 4.22398 21.3163 3.93636 20.7518C3.60938 20.1101 3.60938 19.27 3.60938 17.5898V5.52266Z' fill='%23${theme.customColors.systemPrimary01.replace("#", "")}' opacity='0.7'/%3E%3Cpath d='M21.9618 23.0283H7.02211C4.78694 23.0283 2.98438 21.2102 2.98438 18.9882V4.05447C2.98438 2.79917 3.5612 1.63045 4.54179 0.865724C4.84462 0.620435 5.30608 0.67815 5.55122 0.995582C5.79637 1.31301 5.73869 1.7603 5.42144 2.00559C4.78694 2.49617 4.412 3.24646 4.412 4.0689V18.9882C4.412 20.4167 5.58007 21.5854 7.00769 21.5854H21.9473C23.375 21.5854 24.543 20.4167 24.543 18.9882V4.04004C24.543 3.34747 24.269 2.69817 23.7787 2.19317C23.2884 1.70259 22.6395 1.42844 21.9329 1.42844H9.25729C8.85352 1.44287 8.53627 1.12544 8.53627 0.721436C8.53627 0.317432 8.85352 0.0144287 9.25729 0.0144287H21.9618V0C23.0433 0 24.0527 0.418433 24.817 1.18316C25.5813 1.94788 25.9995 2.95789 25.9995 4.04004V18.9882C25.9995 21.2247 24.1825 23.0283 21.9618 23.0283Z' fill='%23${theme.customColors.systemPrimary01.replace("#", "")}'/%3E%3Cpath d='M22.6979 25.9995H5.77791C2.16672 25.9995 0 22.1868 0 20.0201V5.06341C0 4.58726 0.115364 4.13997 0.331672 3.72154C0.519138 3.36082 0.951753 3.23096 1.29785 3.4041C1.65836 3.59168 1.78814 4.02454 1.6151 4.37083C1.49973 4.58726 1.44205 4.81812 1.44205 5.06341L1.44448 19.4995C1.44448 20.944 2.88896 24.5552 6.50015 24.5552L22.6979 24.5278C23.1593 24.5278 23.6064 24.3402 23.938 23.9795C24.212 23.6909 24.6735 23.6765 24.9619 23.9506C25.2503 24.2248 25.2647 24.6865 24.9763 24.9751C24.3562 25.6243 23.5487 25.9706 22.6834 25.9706L22.6979 25.9995Z' fill='%23${theme.customColors.systemPrimary01.replace("#", "")}'/%3E%3C/svg%3E%0A");`,
    /* eslint-enable max-len */
    backgroundRepeat: "no-repeat",
    content: " '' !important ",
    display: "flex",
    height: "30px",
    minWidth: "25px"
  },
  "&:hover":{
    transform: "scale(1.2)"
  }
}));

export const StyledButtonLink = styled(ButtonLink)(({ theme }) => ({
  color: theme.customColors.textPrimary,
  fontWeight: "400",
  gap: "0.5rem",
  opacity: 0,
  pointerEvents: "none",
  position: "absolute",
  textTransform: "none",
  transition: "all .3s linear",
  zIndex: "1",

  left: "42px",
  top: "32px",

  "&:hover": {
    background: "none",
    boxShadow: "none"
  }
}));

export const StyledIcon = styled(Icon)(() => ({}));

export const StyledCoverLoader = styled(Box)<
  BoxProps & {
  $cover?: string
}
  >(({
    $cover,
    theme }) => ({
    background: `url(${$cover})`,
    backgroundPosition: "center",
    backgroundRepeat:"no-repeat",
    backgroundSize: "cover",
    justifyContent:"flex-end",
    minHeight: "750px",
    overflow: "hidden",

    width: "100%",

    "> main >span":{

      right:"42px"
    },

    [`${StyledButtonBookmark}, ${StyledButtonLink},  ${StyledStatusBox}`]:{
      opacity:1,
      pointerEvents:"auto"
    },

    ".video-caption": {
      height: "fit-content",
      pointerEvents: "none"
    },

    ".icon-play":{
      backgroundColor: theme.customColors.backgroundPrimary,
      border:`1px solid ${theme.customColors.textPrimaryCta}`,
      borderRadius:"50%",
      cursor: "pointer",
      height:"70px",
      margin:"auto",
      width:"70px",

      alignItems:"center",
      display:"flex",
      justifyContent: "center",

      position:"absolute",

      bottom:0,
      left:0,
      right:0,
      top:0
    },


    [theme.breakpoints.down("sm")]: {
      [`${StyledButtonLink}`]:{
        fontSize: "0.75rem",

        [`${StyledIcon}`]:{
          height: "15px",
          width: "12px"
        }
      },

      ".video-caption":{
        "h3":{
          fontSize: "1rem"
        }
      }
    }
  }));

export const StyledPlayerLoader = styled(PlayerLoader)(({ theme }) => ({
  overflow: "hidden",
  position:"relative",

  "&::before":{
    backgroundImage: theme.linearGradients.gradientC,
    content:"''",
    inset:0,
    opacity:1,
    position:"absolute",
    transition:"all .3s linear",
    zIndex:0
  },

  height: "100%",
  width: "100%",

  ">main >span":{
    right:"42px"
  },
  [`${StyledButtonBookmark}`]:{
    right:"170px"
  },

  ".video-caption": {
    height: "fit-content",
    pointerEvents: "none"
  },

  ".video-js": {
    height: "100%",
    width: "100%",

    padding: "0",

    "video": {
      objectFit: undefined
    },

    "span": {
      "&:before":{
        backgroundRepeat: "no-repeat",
        backgroundSize: "contain",
        position: "static"
      }
    },

    ".vjs-big-play-button": {
      alignItems: "center",
      background: "transparent",
      backgroundColor: theme.customColors.backgroundPrimary,
      border: `1px solid ${theme.customColors.textPrimaryCta}`,
      borderRadius: "50%",
      display: "flex",
      justifyContent: "center",

      height: "70px",
      width: "70px",
      zIndex:1,

      "span":{
        "&:before":{
          //eslint-disable-next-line max-len
          backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%23${theme.customColors.backgroundPrimaryCta.replace("#", "")}' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M5 5a2 2 0 0 1 3.008-1.728l11.997 6.998a2 2 0 0 1 .003 3.458l-12 7A2 2 0 0 1 5 19z'/%3E%3C/svg%3E")`,
          color: theme.customColors.textPrimaryCta,
          content: " '' !important ",
          display: "flex",
          position: "static",

          height: "1.5rem",
          width: "1.5rem"
        },
        height: "1.5rem",
        width: "1.5rem"
      }

    },

    ".vjs-control-bar": {
      alignItems: "center",
      background: "transparent",
      bottom: "40px",
      flexWrap: "wrap",
      height: "5rem",
      margin: "0 auto ",
      maxWidth: "1440px",
      padding:"0 42px",
      transform: "translateY(0) !important",
      zIndex:1,

      ".vjs-playback-rate":{
        display: "none",
        height:"40px",
        width:"24px",

        ".vjs-playback-rate-value":{
          height:"fit-content",
          margin:"auto",

          bottom:0,
          rigth:0
        }
      },

      ".vjs-current-time ": {
        marginLeft: "8px"
      },
      ".vjs-current-time, .vjs-duration, .vjs-time-divider ": {
        fontSize: "1rem",
        margin: "0",
        padding: "0"
      },
      ".vjs-fullscreen-control": {
        order: "9999",
        "span":{
          "&:before":{
            //eslint-disable-next-line max-len
            backgroundImage: `url("data:image/svg+xml,%3Csvg%20xmlns='http://www.w3.org/2000/svg'%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20stroke='%23${theme.customColors.textPrimary.replace("#", "")}'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'%3E%3Cpath%20d='M8%203H5a2%202%200%200%200-2%202v3'/%3E%3Cpath%20d='M21%208V5a2%202%200%200%200-2-2h-3'/%3E%3Cpath%20d='M3%2016v3a2%202%200%200%200%202%202h3'/%3E%3Cpath%20d='M16%2021h3a2%202%200%200%200%202-2v-3'/%3E%3C/svg%3E")`
          }
        }
      },
      ".vjs-picture-in-picture-control": {
        display: "none"
      },
      ".vjs-play-control": {
        "span":{

          "&:before": {
            // eslint-disable-next-line max-len
            backgroundImage: `url("data:image/svg+xml,%3Csvg%20xmlns='http://www.w3.org/2000/svg'%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20stroke='%23${theme.customColors.textPrimary.replace("#", "")}'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'%3E%3Crect%20x='14'%20y='3'%20width='5'%20height='18'%20rx='1'/%3E%3Crect%20x='5'%20y='3'%20width='5'%20height='18'%20rx='1'/%3E%3C/svg%3E")`
          }
        },

        "&.vjs-paused":{
          "span":{
            "&:before":{
              //eslint-disable-next-line max-len
              backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%23${theme.customColors.textPrimary.replace("#", "")}' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M5 5a2 2 0 0 1 3.008-1.728l11.997 6.998a2 2 0 0 1 .003 3.458l-12 7A2 2 0 0 1 5 19z'/%3E%3C/svg%3E")`
            }
          }
        }
      },

      ".vjs-progress-control": {
        margin: "0",
        order: "0",
        width: "100%",

        maxWidth: "1440px",
        padding:"0 42px",


        [theme.breakpoints.down("sm")]: {
          top: "-1.8em"
        },

        ".vjs-load-progress":{
          borderRadius: "40px",

          ">div": {
            background: theme.customColors.backgroundSecondary,
            borderRadius: "40px"
          }
        },

        ":hover .vjs-progress-holder": {
          fontSize: "inherit"
        },

        // "&:hover ": {

        //   ".vjs-progress-holder .vjs-play-progress": {
        //     "&:before": {
        //       bottom: "-0.9em",
        //       height: "30px",
        //       width: "30px"
        //     }
        //   }

        // },

        ".vjs-play-progress": {
          backgroundColor: theme.palette.secondary?.main,
          borderRadius: "40px",
          position: "relative",

          "&:before": {
            backgroundColor: theme.palette.secondary?.main,
            border: `2px solid ${theme.customColors.borderTag}`,
            borderRadius: "40px",
            bottom: "-0.5em",
            content: "''",
            display: "flex",
            height: "24px",
            width: "24px",
            zIndex:0,

            position: "absolute"
          }

        },

        ".vjs-progress-holder": {
          backgroundColor: theme.customColors.backgroundSecondary,
          borderRadius: "40px",
          height: "7px",
          margin: "0"
        },

        ".vjs-time-tooltip": {
          top: "-5.4em"
        }
      },
      ".vjs-subs-caps-button": {
        alignItems: "center",
        cursor: "pointer",
        display: "none",
        order: "9999",
        padding: "0",

        "span": {
          "&:before": {
            //eslint-disable-next-line max-len
            backgroundImage: `url("data:image/svg+xml,%3Csvg%20xmlns='http://www.w3.org/2000/svg'%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20stroke='%23${theme.customColors.textPrimary.replace("#", "")}'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'%3E%3Crect%20width='18'%20height='14'%20x='3'%20y='5'%20rx='2'%20ry='2'/%3E%3Cpath%20d='M7%2015h4M15%2015h2M7%2011h2M13%2011h4'/%3E%3C/svg%3E")`
          }
        },

        ".vjs-menu ":{
          ".vjs-menu-content":{
            bottom: "2.5em",
            zIndex: 4
          }
        }
      },
      ".vjs-time-divider ": {
        minWidth: "unset",
        width: "10px"
      },
      ".vjs-volume-panel ": {
        marginRight: "0",

        "span":{
          "&:before":{
            //eslint-disable-next-line max-len
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='26' height='26' viewBox='0 0 26 26' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 12.9905V11.1185C1 9.06994 2.18736 7.39223 3.66524 7.39223H6.49469C6.96206 7.39223 7.41679 7.21563 7.821 6.89775L11.7368 3.73661C12.5831 3.06552 13.6315 3.91321 13.6315 5.27303V17.3878' stroke='%23${theme.customColors.systemPrimary01.replace("#", "")}' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M17.9131 6.12109C19.1762 7.8871 19.9468 10.3065 19.9468 12.9909C19.9468 15.6752 19.2015 17.9886 17.9889 19.737' stroke='%23${theme.customColors.systemPrimary01.replace("#", "")}' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M21.4131 1C23.6362 4.09051 25.0004 8.3819 25.0004 13.1148C25.0004 17.8477 23.6868 21.9272 21.5647 25' stroke='%23${theme.customColors.systemPrimary01.replace("#", "")}' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M1 12.9922V14.8642C1 16.9127 2.18736 18.5904 3.66524 18.5904H6.48206C6.94942 18.5904 7.41679 18.767 7.83363 19.0849L11.1052 21.6809C11.8883 22.299 12.861 22.299 13.6441 21.6456L13.7452 21.5573' stroke='%23${theme.customColors.systemPrimary01.replace("#", "")}' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");`
          }
        },

        ".vjs-volume-bar": {
          borderRadius: "4px",
          height: "0.3rem"
        },
        ".vjs-volume-learningObjectTypology": {
          backgroundColor: theme.palette.secondary?.main,
          borderRadius: "4px",
          height: "0.3rem"
        }
      },
      ".vjs-volume-panel, .vjs-play-control, .vjs-fullscreen-control, .vjs-subs-caps-button": {
        "&:hover": {
          transform: "scale(1.2)"
        },
        "span":{
          "&:before":{
            content: "'' !important",
            display: "flex",
            height: "24px",
            width: "24px"
          },
          height: "24px",
          width: "24px"
        },
        transition: "all .3s ease"
      },
      "> div, > button": {
        alignItems: "center",
        margin: "0 0.5rem",
        order: "1",
        width: "fit-content"
      }
    },

    ".vjs-poster": {
      "img": {
        objectFit: "cover"
      }
    },

    "picture.vjs-poster::after": {
      content: "\"\"",
      position: "absolute",
      inset: 0,
      background: theme.linearGradients.gradientC,
      zIndex: 1,
      pointerEvents: "none"
    },

    ".vjs-title-bar": {
      display: "none"
    }
  },

  "> div": {
    height: "100%"
  },
  ">main":{
    pointerEvents:"none",
    zIndex: 1
  },

  [` >main >span, .video-caption, #completed-tag-brightcove, ${StyledButtonBookmark}, ${StyledStatusBox}`]: {
    opacity: 0,
    pointerEvents: "none",
    transition: "all .3s linear"
  },

  "&.brightcove-is-paused": {
    [`>main >span, ${StyledButtonLink}, ${StyledButtonBookmark}`]: {
      pointerEvents: "auto"
    },
    [`>main >span, .video-caption, #completed-tag-brightcove,
    ${StyledButtonLink},
    ${StyledButtonBookmark},
    ${StyledButtonBookmark},
    ${StyledStatusBox}`]: {
      opacity: 1
    },

    "&::before":{
      opacity:1,
      zIndex:1
    }
  },

  "&.brightcove-is-playing":{

    ".vjs-big-play-button": {
      display: "none"
    },

    ".vjs-control-bar": {
      opacity: "0 !important"
    },

    "&::before":{
      opacity:0,
      zIndex:0
    },

    "&:hover":{
      [` ${StyledButtonBookmark}, ${StyledStatusBox},  .vjs-control-bar`]: {
        opacity: "1 !important",
        pointerEvents: "auto"
      },

      "&::before":{
        opacity:1,
        zIndex:1
      }
    }
  },

  "&:hover": {
    [`> main >span, ${StyledButtonLink}`]: {
      pointerEvents: "auto"
    },
    [`> main >span, .video-caption, ${StyledButtonLink}, ${StyledStatusBox}`]: {
      opacity: 1
    }
  },

  [theme.breakpoints.down("sm")]: {
    [`${StyledButtonLink}`]:{
      fontSize: "0.75rem",

      [`${StyledIcon}`]:{
        height: "15px",
        width: "12px"
      }
    },
    ".video-caption":{
      "h3":{
        fontSize: "1rem"
      }
    }
  }
}));

export const StyledStatusBox = styled(StatusBox)(({ theme }) => ({
  left: "0",
  marginBottom: "42px",
  opacity: "0",
  position: "absolute",
  top: "25%",
  zIndex: theme.zIndex.appBar,

  height: "60px",
  width: "60px",

  "svg":{
    height:"30px !important",
    width:"30px !important"
  },

  [theme.breakpoints.down("sm")]: {
    left: "-20px",

    height: "40px",
    width: "40px",

    [`${StyledIcon}`]:{
      height: "24px",
      width: "24px"
    }
  }
}));

export const VideoStack = styled(Stack)(({ theme }) => ({
  background: theme.palette.background?.paper,
  [`${StyledPlayerLoader}`]:{
    ".vjs-control-bar":{
      height:"fit-content"
    }
  },
  "main":{
    padding:"16px"
  },

  [theme.breakpoints.down("sm")]:{
    height: "450px",

    [`${CtaOverlayContainer}`]: {
      display: "none"
    }
  }
}));

export const TitleTypography = styled(Typography)(({ theme }) => ({
  fontSize: "1.25rem",
  fontWeight:"700",
  lineHeight: 7 / 6,
  textShadow: `0 0 1.25rem ${alpha(theme.palette.background?.paper ?? common["black"], 0.25)}`
}));

//video caption

export const VideoCaptionStyles = styled(Stack)(() => ({
  position:"absolute",

  bottom:"20px",
  left:"42px",

  fontSize:"2rem",
  maxWidth:"600px",
  padding:"0 0 68px",
  zIndex:"1"

}));
